<template>
  <div class="p-5 bg-white rounded non-print">
    <div class="py-6 text-xl text-center">{{ $t('payment.deposit_refund_list') }}</div>
    <between-date @onClick="fetchCheckout"></between-date>
    <div class="flex justify-end py-3">
      <v-btn class="blue white--text mx-1" @click="exportExcel">
        <v-icon left>mdi-file-excel</v-icon>Export Excel
      </v-btn>
      <v-btn class="blue white--text mx-1" @click="printPDF">
        <v-icon left>mdi-file-excel</v-icon>{{ $t('print_pdf') }}
      </v-btn>
      <FilterColumnDataTable v-model="headers" @onSuccess="onSelectFilterColumn" dataTableName="ReportCashback" />
    </div>
    <div class="py-5">
      <!-- <pre>      {{ checkouts }}</pre> -->
      <!-- {{ selected }} -->
      <v-data-table
        :headers="currentHeaders"
        :items="checkouts"
        :loading="loading"
        :search="search"
        :show-select="showSelect"
        item-key="objectId"
        v-model="selected"
        class="elevation-1 v-data-table-report data-table-cashback"
        @toggle-select-all="selectAll"
        :items-per-page="itemsPerPage"
        id="printarea"
        :no-data-text="$t('noinfo')"
        :no-results-text="$t('no_matching_records_found')">
        <template v-slot:top>
          <div class="px-2 py-2 non-print">
            <v-btn
              color="gray lighten-4 mr-2"
              @click="selectAll"
              :disabled="isSelectAllDisabled"
            >
              {{ $t('select_all') }}
            </v-btn>
            <v-btn
              color="primary"
              :disabled="selected.length < 1 || checkouts.length === 0"
              @click="isCPayment = true"
            >
              {{ $t('payment.refund') }} {{ selected.length }} {{ $t('list') }}
            </v-btn>
          </div>
        </template>
        
        <template v-slot:header.data-table-select>
          <v-simple-checkbox
            :disabled="isSelectAllDisabled || checkouts.length == 0"
            color="primary"
            @input="selectAll"
            :value="selected.length > 0 && selected.length === selectableItems.length"
            :indeterminate="selected.length > 0 && selected.length < selectableItems.length"
            hide-details>
          </v-simple-checkbox>
        </template>
        <template v-slot:header.customerData="{header}">
          <div class="text-nowrap-table customer-name" style="min-width:100px;">{{header.text}}</div>
        </template>
        <template v-slot:header.contract="{header}">
          <div class="text-nowrap-table business-name" style="min-width:100px;">{{header.text}}</div>
        </template>
        <template v-slot:header.areas="{header}">
          <div class="text-nowrap-table area-name" style="min-width:100px;">{{header.text}}</div>
        </template>
        <template v-slot:header.products="{header}">
          <div class="text-nowrap-table product-name" style="min-width:100px;">{{header.text}}</div>
        </template>
        <template v-slot:header.getReceivedBy="{header}">
          <div class="text-nowrap-table customer-name" style="min-width:100px;">{{header.text}}</div>
        </template>

        <template v-slot:body.prepend>
          <tr>
            <td class="text-center">
              <v-icon>mdi-filter-multiple-outline</v-icon>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <v-select v-model="filterData.status" :items="filterOption.status" type="text" :label="$t('payment.payment_status')" solo
                dense hide-details clearable :no-data-text="$t('noinfo')"></v-select>
            </td>
            <td></td>
            <td></td>
          </tr>
        </template>
        <template v-slot:item.payDate="{ item }">
          <div>{{ item.payDate ? $moment(item.payDate).format("DD/MM/YYYY") : "" }}</div>
        </template>
        <template v-slot:item.data-table-select="{ item, isSelected, select }">
          <!-- {{ item }} -->
          <v-simple-checkbox
            v-if="(item.status == 'pending' || item.status == 'success')
                   && item.status != 'rejected' && item.approveStatus != 'rejected'"
            :value="isSelected"
            :disabled="item.isPaid || item.status == 'rejected'
                       || item.approveStatus == 'rejected'"
            @input="select($event)"
            color="primary"
            hide-details>
          </v-simple-checkbox>
        </template>
        <template v-slot:item.checkOutDate="{ item }">
          <div>{{ $moment(item.checkOutDate).format("DD/MM/YYYY") }}</div>
        </template>
        <template v-slot:item.customerData="{ item }">
          <div class="text-truncate">{{ item.customerData ? item.customerData.name : "-" }}</div>
        </template>
        <template v-slot:item.contract="{ item }">
          <div class="text-truncate">{{ item.contract ? item.contract.businessName : "-" }}</div>
        </template>
        <template v-slot:item.areas="{ item }">
          <div class="text-truncate"> {{ item.areas ? item.areas.map((i) => i.name).join(", ") : "-" }}
          </div>
        </template>
        <template v-slot:item.areaSize="{ item }">
          {{
            item.areas
            ? item.areas.reduce((acc, i) => acc + i.size, 0)
            : "-" | currency
          }}
        </template>
        <template v-slot:item.getReceivedBy="{ item }">
          <div class="text-truncate"> {{ item.getReceivedBy || '-' }} </div>
        </template>
        <template v-slot:item.cost="{ item }">
          <div class="text-no-wrap text-right">{{ item.totalCostAbs | currencyPrefixSign }}</div>
        </template>
        <template v-slot:item.sumStatus="{ item }">
          <v-chip v-if="item.isPaidClass" :color="item.isPaidClass.color">{{ item.isPaidClass.text }}</v-chip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip v-if="item.statusClass" :color="item.statusClass.color">{{ item.statusClass.text }}</v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="flex justify-end"
            v-if="(item.status == 'pending' || item.status == 'success') && item.status != 'rejected' && item.approveStatus != 'rejected'">
            <v-btn @click="getContractCheckoutFn(item)"
              class="px-4 py-2 text-white bg-blue-500 rounded-full hover:bg-blue-700" elevation="0"
              rounded>{{ $t('view_detail') }}</v-btn>
          </div>
        </template>
      </v-data-table>
    </div>
    <checkout-payment2 v-model="isCheckoutPayment" @onSuccess="fetchCheckout" @onSuccessCheckout="fetchCheckout"
      :isCreate="true"></checkout-payment2>
    <v-dialog v-model="isCheckoutLoading" persistent max-width="500px">
      <v-card height="250">
        <!-- v-overlay -->
        <v-overlay color="white" :absolute="true">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>
    <PaymentFormDialog
      v-model="isCPayment"
      :isHideSplitPay="true"
      dialogType="refund"
      :contractCheckouts="selected"
      @onSaveSuccess="fetchCheckout()"
    />
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import { Excel } from "../exports";
import BetweenDate from "./BetweenDate.vue";
import CheckoutPayment2 from "./CheckoutPayment.vue";
import CPayment from "./CPayment.vue";
import FilterColumnDataTable from "@/components/FilterColumnDataTable.vue"
import PaymentFormDialog from "@/components/paymentFormDialog.component.vue"
export default {
  components: { BetweenDate, CheckoutPayment2, CPayment, FilterColumnDataTable, PaymentFormDialog },
  computed: {
    ...mapState({
      checkouts: state =>
        state.contractCheckout.checkouts.filter(i => {
          if (i.totalCost > 0) return i;
        })
    }),
    ...mapGetters({ 
      getFullName: "user/getFullName",
      getAdminByMarketId: "admin/getByMarketId",
      getEmployeeByMarketId: "employee/getByMarketId",
    }),
    selectableItems() {
      return this.checkouts.filter(i => 
        !i.isPaid &&
        (i.status == "pending" || i.status == "success") &&
        i.status != "rejected" &&
        i.approveStatus != "rejected"
      );
    },
    userFullName() {
      return this.getFullName;
    },
    admin() {
      return this.getAdminByMarketId(this.marketId);
    },
    employee() {
      return this.getEmployeeByMarketId(this.marketId);
    },
    currentHeaders() {
      return this.headers && this.headers.length ? this.headers.filter(h => h.isShow) : []; // filter(h=>h.isShow == true)
    },
    hasSelectableItems() {
      return this.checkouts.some(i => 
        !i.isPaid &&
        (i.status == "pending" || i.status == "success") &&
        i.status != "rejected" &&
        i.approveStatus != "rejected"
      );
    },
    isSelectAllDisabled() {
      return !this.hasSelectableItems || this.checkouts.length === 0;
    }
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      project: null,
      market: null,
      date: {
        startDate: this.$moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        endDate: this.$moment()
          .endOf("month")
          .format("YYYY-MM-DD")
      },
      isCPayment: false,
      selected: [],
      headers: [],
      search: "",
      page: 1,
      rowsPerPage: 50,
      loading: false,
      isCheckoutPayment: false,
      isCheckoutLoading: false,
      disabledCount: 0,
      startDate: this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: this.$moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      showSelect: true,
      itemsPerPage: 10,
      filterData: {
        status: null
      },
      filterOption: {
        status: []
      }
    };
  },
  created() {
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }

    this.headers = [
        {
          text: this.$t('date'),
          align: "center",
          value: "checkOutDate",
          width: "100px"
        },
        {
          text: this.$t('payment.refund_date'),
          align: "center",
          value: "payDate",
          width: "100px"
        },
        {
          text: this.$t('customer.title'),
          align: "center hd-resize",
          value: "customerData",
          width: "150px",
          sortable:false,
        },
        {
          text: this.$t('area.shop_name'),
          align: "center hd-resize",
          value: "contract",
          width: "150px",
          sortable:false,
        },
        {
          text: this.$t('market.market_title'),
          align: "center hd-resize",
          value: "areas",
          width: "100px",
          sortable:true,
          class : 'custom-sort'
        },
        {
          text: this.$t('area.space'),
          align: "center",
          value: "areaSize",
          width: "80px",
          class: "text-right",
        },
        {
          text: this.$t('project.employee'),
          align: "center hd-resize",
          value: "getReceivedBy",
          width: "150px",
          sortable:false,
        },
        {
          text: this.$t('payment.total'),
          align: "center",
          value: "cost",
          width: "100px",
          class: "text-right",
          cellClass: "text-right"
        },
        {
          width: "150px",
          text: this.$t('payment.payment_status'),
          value: "sumStatus",
          align: "center",
          width: "200px",
          filter: d =>
            this.filterData.status ? d == this.filterData.status : d
        },
        {
          width: "150px",
          text: this.$t('area.checkout_status'),
          value: "status",
          align: "center"
        },
        {
          width: "100%",
          text: "",
          align: "center",
          value: "actions",
          class: "non-print",
          cellClass: "non-print"
        }
    ];

    this.filterOption.status = [
          this.$t('draft'),
          this.$t('payment.wait_approval'),
          this.$t('task.not_approve'),
          this.$t('area.cancel_draft'),
          this.$t('payment.wait_transfer_money'),
          this.$t('payment.refunded'),
          this.$t('payment.paid_money'),
          this.$t('payment.wait_refund'),
          this.$t('payment.wait_payment'),
          this.$t('payment.no_expense')
    ];

    this.intiDataTable();
    this.fetchCheckout();
  },
  methods: {
    ...mapActions({
      getContractCheckout: "contractCheckout/getContractCheckout",
      getContractCheckoutsBetweenDateByMarket: "contractCheckout/getContractCheckoutsBetweenDateByMarket"
    }),
    intiDataTable() {
      if (this.headers && this.headers.length) {
        for (let header of this.headers) {
          if (header.isShow === undefined) header.isShow = true
          else header.isShow = false
        }
      }
      this.onSelectFilterColumn(this.headers.filter(h => h.isShow).map(h => h.value))
    },
    onSelectFilterColumn(hs) {
      let resHeaders = []
      let hst = []
      let filterDataTable = localStorage.getItem("filterDataTable");
      filterDataTable = filterDataTable ? JSON.parse(filterDataTable) : null
      let lhs = filterDataTable && filterDataTable['ReportCashback'] ? filterDataTable['ReportCashback'] : null
      if (lhs && lhs.length) hst = lhs
      else if (hs) hst = hs
      for (let header of this.headers) {
        header.isShow = hst.find(h => h == header.value) ? true : false;
        resHeaders.push(header)
      }
      this.headers = resHeaders
    },
    async exportExcel() {
      try {
        await Excel.generateExcel(this.checkouts, this.startDate, this.endDate);
      } catch (e) {
        console.log(e);
      }
    },
    selectAll() {
      const filter = this.checkouts.filter(i => {
        if (
          !i.isPaid &&
          (i.status == "pending" || i.status == "success") &&
          i.status != "rejected" &&
          i.approveStatus != "rejected"
        ) {
          return i;
        }
      });
      if (this.selected.length == filter.length) {
        this.selected = [];
      } else {
        this.selected = filter;
      }
      console.log(this.selected.length)
      console.log(filter.length)
    },
    async getContractCheckoutFn(item) {
      try {
        this.isCheckoutLoading = true;
        const id = item.objectId;
        await this.getContractCheckout({ id });
        this.isCheckoutPayment = true;
        this.isCheckoutLoading = false;
      } catch (e) {
        console.log(e);
      }
    },
    async fetchCheckout(value) {
      if (this.marketId && this.marketId != "") {
        this.loading = true;
        this.selected = [];
        await this.getContractCheckoutsBetweenDateByMarket({
          marketId: this.marketId,
          startDate: value?.startDate || this.$moment(this.startDate).startOf("day").toISOString(),
          endDate: value?.endDate || this.$moment(this.endDate).endOf("day").toISOString()
        }
        );
        if (value?.startDate && value?.endDate) {
          this.startDate =
            this.$moment(value?.startDate).format("YYYY-MM-DD") ||
            this.$moment()
              .startOf("month")
              .format("YYYY-MM-DD");
          this.endDate =
            this.$moment(value?.endDate).format("YYYY-MM-DD") ||
            this.$moment()
              .endOf("month")
              .format("YYYY-MM-DD");
        }
        this.loading = false;
      }
    },
    printPDF() {
      this.showSelect = false;
      const tempItemsPerPage = this.itemsPerPage;
      this.itemsPerPage = -1;
      setTimeout(() => {
        let printarea = document.getElementById("printarea").innerHTML;
        let printPreviewTopic = document.getElementById("print-preview-topic");
        let printPreviewcontent = document.getElementById(
          "print-preview-content"
        );
        let printPreviewFooter = document.getElementById(
          "print-preview-footer"
        );

        printPreviewTopic.innerHTML = `
          <h2 style="text-align: center;" class="my-4">
            <b>${this.$t('payment.deposit_refund_list')}</b>
          </h2>
          <p style="text-align: center;">${this.market.name}</p>
          <p style="text-align: center;">
            ${this.$moment(this.startDate, "YYYY-MM-DD").format(
          "D MMMM YYYY"
        )} - ${this.$moment(this.endDate, "YYYY-MM-DD").format(
          "D MMMM YYYY"
        )}
          </p>
        `;
        printPreviewcontent.innerHTML = printarea;
        printPreviewFooter.innerHTML = `<div style="text-align: right;"><b>${this.$t('print_by')} : </b>${this.userFullName
          } <b>${this.$t('when')}</b> ${this.$moment().format("lll")}</div>`;
        window.print();
        this.showSelect = true;
        this.itemsPerPage = tempItemsPerPage;
      }, 200);
    }
  }
};
</script>

<style lang="scss" scoped>
.text-nowrap-table {
  text-align: center;
}
.data-table-cashback::v-deep td {
  max-width: 200px;
}

.data-table-cashback::v-deep td.hd-resize {
  max-width: 100px;
}

.data-table-cashback::v-deep td.hd-resize.area-name {
  max-width: 80px;
}

.data-table-cashback::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 24px;
    top: 18px;
  }
}
</style>